module.exports = __webpack_public_path__ + "title-1.svg?f48839a22b92f29173b16018d4fec115";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title-1.svg
// module id = 98
// module chunks = 0